/**
 * Parse an SSE stream from a fetch Response.
 *
 * Handles the case where a single event contains multiple "data:" lines
 * (which per SSE spec should be joined with \n). Yields each event's
 * concatenated data string to onChunk as it arrives.
 *
 * Returns nothing. Errors bubble up to the caller.
 */
export async function readSSEStream(response, onChunk) {
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });

    const events = buffer.split('\n\n');
    buffer = events.pop() || '';

    for (const event of events) {
      const dataLines = event
        .split('\n')
        .filter((l) => l.startsWith('data:'))
        .map((l) => (l.startsWith('data: ') ? l.slice(6) : l.slice(5)));
      if (dataLines.length > 0) {
        onChunk(dataLines.join('\n'));
      }
    }
  }
}
